import { api } from "./configs/axiosConfigs"

export const CartolaBuildingAPI = {
    get: async (payload?: object) => {
        const response = await api.get(
            '/cartola-building', { params: payload }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    generatePDF: async (idbuilding: number, start_date: string, end_date: string, idcompany: number) => {
        const response = await api.get(
            '/cartola-building/PDF',
            {
                params: {
                    idbuilding,
                    start_date,
                    end_date,
                    idcompany
                },
                responseType: 'blob'
            }
        ).then(response => response)
            .catch((error) => {
                console.error(error)
                return error.response
            })
        return response
    },
}